import React from "react";

const styles = {
  container: {
    height: "100vh",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #ffedd5, #fed7aa)",
    fontFamily: "'Poppins', sans-serif",
    textAlign: "center",
    color: "#1f2937",
    overflow: "hidden",
  },
  emoji: {
    fontSize: "5rem",
    animation: "bounce 2s infinite",
  },
  heading: {
    fontSize: "2.5rem",
    fontWeight: "800",
    margin: "1rem 0",
    color: "#f97316",
    textShadow: "2px 2px 5px rgba(0,0,0,0.2)",
  },
  subText: {
    fontSize: "1.2rem",
    maxWidth: "500px",
    lineHeight: "1.6",
    marginBottom: "2rem",
  },
  button: {
    backgroundColor: "#f97316",
    color: "#fff",
    padding: "0.9rem 1.6rem",
    fontSize: "1rem",
    border: "none",
    borderRadius: "2rem",
    cursor: "pointer",
    fontWeight: "600",
    transition: "all 0.3s ease",
  },
  footer: {
    marginTop: "3rem",
    fontSize: "0.9rem",
    opacity: 0.8,
  },
};

// funny CSS bounce animation
const bounceKeyframes = `
@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-15px); }
}
`;

export default function ComingSoon() {
  return (
    <>
      <style>{bounceKeyframes}</style>
      <div style={styles.container}>
        <div style={styles.emoji}>🥘</div>
        <h1 style={styles.heading}>Something Delicious is Cooking!</h1>
        <p style={styles.subText}>
          We're not late... we're just slow-cooking this page to perfection.  
          Come back soon or bring snacks while you wait 🍿😋
        </p>
        <button
          style={styles.button}
          onMouseEnter={(e) => (e.target.style.backgroundColor = "#ea580c")}
          onMouseLeave={(e) => (e.target.style.backgroundColor = "#f97316")}
          onClick={() => window.history.back()}
        >
          Go Back Before You Get Hungry
        </button>
        <p style={styles.footer}>🚧 Page under construction · ETA: before your next meal!</p>
      </div>
    </>
  );
}
